import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star\">\n<path d=\"M9.99786 14.6467L15.1679 17.7667C15.5479 17.9967 16.0179 17.6567 15.9179 17.2267L14.5479 11.3467L19.1079 7.39668C19.4379 7.10668 19.2679 6.55668 18.8179 6.51668L12.8079 6.00668L10.4579 0.46668C10.2879 0.0566797 9.70786 0.0566797 9.53786 0.46668L7.18786 6.00668L1.17786 6.51668C0.737859 6.55668 0.557859 7.10668 0.897859 7.39668L5.45786 11.3467L4.08786 17.2267C3.98786 17.6567 4.45786 17.9967 4.83786 17.7667L9.99786 14.6467Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/star.svg
// module id = hcXm
// module chunks = 13